import request from './requesters/service-provider.request';
import { PaginationData, QueryParams } from 'shared/types';
import WasteCenter from '../models/waste-center.model';

type ServiceProviderWasteCenterRow = {
  WasteCenter?: WasteCenter;
  isPrimary?: boolean;
};

const wasteCenterService = {
  getWasteCenters: async (params: QueryParams & { serviceProviderId?: number }) => {
    const { serviceProviderId, ...otherParams } = params;

    if (!serviceProviderId) {
      return {
        count: 0,
        rows: [],
      } as PaginationData<WasteCenter>;
    }

    const response = await request.get<PaginationData<ServiceProviderWasteCenterRow>>(
      `/service-providers/${serviceProviderId}/waste-centers`,
      { params: otherParams },
    );

    const rows: WasteCenter[] = Array.isArray(response.rows)
      ? response.rows
          .filter(
            (
              item,
            ): item is Required<Pick<ServiceProviderWasteCenterRow, 'WasteCenter'>> & ServiceProviderWasteCenterRow =>
              !!item.WasteCenter,
          )
          .map((item) => ({
            ...item.WasteCenter!,
            isPrimary: !!item.isPrimary,
          }))
      : [];

    return {
      ...response,
      rows,
      count: response.count ?? rows.length,
    } as PaginationData<WasteCenter>;
  },
  getDecheteriesList: (params: QueryParams & { serviceProviderId?: number }) =>
    request.get<PaginationData<WasteCenter>>('/waste-centers', { params }),
  findWasteCenter: (wasteCenterId: number) => request.get(`/waste-centers/${wasteCenterId}`),
  createWasteCenter: (data: Partial<WasteCenter>) => request.post<WasteCenter>('/waste-centers', data),
  deleteServiceProviderWasteCenter: (serviceProviderId: number, wasteCenterId: number) =>
    request.delete(`/service-providers/${serviceProviderId}/waste-centers/${wasteCenterId}`),
  createServiceProviderWasteCenter: (serviceProviderId: number, data: { wasteCenterId: number; isPrimary: boolean }) =>
    request.post(`/service-providers/${serviceProviderId}/waste-centers`, data),
  setDefaultServiceProviderWasteCenter: (serviceProviderId: number, wasteCenterId: number) =>
    request.put(`/service-providers/${serviceProviderId}/waste-centers/${wasteCenterId}/default`, {
      wasteCenterId,
    }),
  updateWasteCenter: (wasteCenterId: number, data: Partial<WasteCenter>) =>
    request.put<WasteCenter>(`/waste-centers/${wasteCenterId}`, data),
  deactivateWasteCenter: (wasteCenterId: number, params: Record<string, unknown>) =>
    request.delete(`/waste-centers/${wasteCenterId}`, { params }),
};

export default wasteCenterService;
